import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, TextField, Tooltip } from "@mui/material";
import { useState } from "react";

export interface CopyableTextFieldProps {
  label: string;
  value: string;
}

export function CopyableTextField(props: CopyableTextFieldProps): JSX.Element {
  const { label, value } = props;

  const [isCopied, setIsCopied] = useState<boolean>(false);

  function handleCopy(): void {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    navigator.clipboard.writeText(value);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  }

  return (
    <TextField
      fullWidth
      label={label}
      value={value}
      variant="filled"
      size="small"
      InputProps={{
        readOnly: true,
        endAdornment: (
          <Tooltip title={isCopied ? "Copied!" : "Copy"}>
            {/* eslint-disable-next-line react/jsx-no-bind */}
            <IconButton edge="end" onClick={handleCopy}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        ),
        sx: {
          fontSize: "0.8rem",
        },
      }}
      sx={{
        backgroundColor: "lightgray",
      }}
    />
  );
}
